import { getAPIHost } from '@rsos/utils/metaTags';
import fetchRetry from '../fetchRetry';
import { DELETE_INTEGRATION_CREDENTIAL_SUCCESS } from './types';

const baseURL = `${getAPIHost()}/v1/capstone`;

export const deleteIntegrationCredentialSuccess = payload => ({
  type: DELETE_INTEGRATION_CREDENTIAL_SUCCESS,
  payload,
});

/**
 * @param {String} orgID - sinatra org id
 * @param {Object} selectedCredential - preselected cred from inbound table
 */

export const deleteIntegrationCredential =
  (orgID, selectedCredential) => async dispatch => {
    const id = selectedCredential.internal_id;
    try {
      return await fetchRetry(
        `${baseURL}/psaps/${orgID}/authority-credentials/${id}`,
        {
          method: 'DELETE',
        },
      ).then(response => {
        dispatch(deleteIntegrationCredentialSuccess(id));
        return response;
      });
    } catch (error) {
      return error;
    }
  };

export default deleteIntegrationCredential;
